import React from 'react';
import './LoanTopUp.scss';

function LoanTopUp({ onClosePopup }) {
  

  return (
    <div>

    </div>
  );
}

export default LoanTopUp;